import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import ParameterDatalakeFincsMarketDataTable from 'src/pages/parameters/parameters-datalake/tables/parameter-datalake-fincs-marketdata-table'
import { DATALAKE_FINCS_MARKET_DATA_PATH } from 'src/utils/api-routes'

const TableFincsMarketData = ({ loading, cetipIsin }) => {
    const cetip = useMemo(
        () => (cetipIsin?.CETIP ?? '').toString().trim(),
        [cetipIsin]
    )
    const isin = useMemo(
        () => (cetipIsin?.ISIN ?? '').toString().trim(),
        [cetipIsin]
    )

    const filters = useMemo(() => {
        // Se CETIP existir, filtramos só por ele
        if (cetip) {
            return [{ field: 'cetip__exact', value: cetip }]
        }

        // Se CETIP não existir mas ISIN existir → filtra só pelo ISIN
        if (isin) {
            return [{ field: 'isin__exact', value: isin }]
        }

        // Nenhum dos dois → sem filtro
        return []
    }, [cetip, isin])

    const tableKey = useMemo(
        () => `fincs-${cetip || 'no-cetip'}-${isin || 'no-isin'}`,
        [cetip, isin]
    )

    return (
        <ParameterDatalakeFincsMarketDataTable
            key={tableKey}
            disableToolbar
            filters={filters}
            endpoint={`${DATALAKE_FINCS_MARKET_DATA_PATH}?`}
            loading={loading}
        />
    )
}

TableFincsMarketData.propTypes = {
    loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    cetipIsin: PropTypes.shape({
        CETIP: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        ISIN: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
}

export default TableFincsMarketData